import { CheckIcon } from "@heroicons/react/24/outline"
import { message } from "antd"
import { startTransition } from "react"
import type { Dispatch, SetStateAction } from "react"
import { MAX_FROZEN_COLUMNS } from "./constants"

type FreezeOption = {
  label: string
  value: string
}

export const FreezeColumnsPanel = ({
  frozenColumnKeySet,
  frozenColumnKeys,
  freezeOptions,
  setFrozenColumnKeys,
}: {
  frozenColumnKeySet: Set<string>
  frozenColumnKeys: string[]
  freezeOptions: FreezeOption[]
  setFrozenColumnKeys: Dispatch<SetStateAction<string[]>>
}) => (
  <div className="w-[260px] max-w-[80vw] py-1 font-avenir">
    {freezeOptions.map((option) => {
      const isNoFreezeOption = !option.value
      const isChecked =
        !isNoFreezeOption && frozenColumnKeySet.has(option.value)
      const isActive = isNoFreezeOption ? !frozenColumnKeys.length : isChecked

      return (
        <button
          key={option.value || "no-freeze"}
          type="button"
          className={`flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm transition-colors ${
            isActive
              ? "bg-primary50 text-primary500"
              : "text-neutral600 hover:bg-neutral20"
          }`}
          onClick={() => {
            startTransition(() => {
              if (isNoFreezeOption) {
                setFrozenColumnKeys([])
                return
              }

              setFrozenColumnKeys((current) => {
                if (current.includes(option.value)) {
                  return current.filter((key) => key !== option.value)
                }

                if (current.length >= MAX_FROZEN_COLUMNS) {
                  message.warning(
                    `You can freeze up to ${MAX_FROZEN_COLUMNS} columns.`
                  )
                  return current
                }

                return [...current, option.value]
              })
            })
          }}
        >
          <span
            className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border ${
              isChecked
                ? "border-primary500 bg-primary500 text-white"
                : "border-neutral100 bg-white text-transparent"
            }`}
          >
            <CheckIcon className="h-3 w-3" />
          </span>
          <span>{option.label}</span>
        </button>
      )
    })}
  </div>
)
